// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__25jN8","empty":"ModalGraph_empty__rMfO1"};